export default __webpack_public_path__ + "static/media/Mask Group 65.ad92e396.jpg";